import { COLORS } from '../styles/tokens';

export const ROUTE_META = {
  training: {
    label: 'AI Training',
    color: COLORS.slateBlue,
    icon: 'school',
    headline: 'Start with understanding.',
    subhead: "Your team's first job is to see what these tools can actually do.",
    bookingUrl: 'https://tidycal.com/adell1',
  },
  audit: {
    label: 'AI Audit & Consulting',
    color: COLORS.holidayBlue,
    icon: 'search',
    headline: 'Find the right thing to build first.',
    subhead: 'You feel the pain. The audit turns it into a ranked plan.',
    bookingUrl: 'https://tidycal.com/adell1',
  },
  build: {
    label: 'AI Execution & Build',
    color: '#6B91FF',
    icon: 'build',
    headline: 'You know what you want. Let\'s build it.',
    subhead: 'A scoped, fixed-fee engagement that ships.',
    bookingUrl: 'https://tidycal.com/adell1',
  },
  discovery: {
    label: 'Discovery Conversation',
    color: COLORS.slateBlue,
    icon: 'chat',
    headline: 'The right next step is a real conversation.',
    subhead: 'No decks. No proposal. Just honest context.',
    bookingUrl: 'https://tidycal.com/adell1',
  },
  nurture: {
    label: 'Stay Connected',
    color: COLORS.medGray,
    icon: 'mail',
    headline: 'Not the moment — and that\'s okay.',
    subhead: 'Here\'s what\'s worth doing while you wait.',
    bookingUrl: 'https://tidycal.com/adell1',
  },
};
